/**
 * Debug mode — PII-masked structured logging (attr-security rules):
 * mask email/phone, key = prefix+last4, never raw IP, redact free-text,
 * never log raw PII-bearing external IDs.
 */
import { maskEmail, maskKey, maskPhone } from './util';

let enabled = false;

export function setDebug(on: boolean): void {
  enabled = !!on;
}

export function isDebug(): boolean {
  return enabled;
}

/** Resolve initial debug from query/localStorage/option — all guarded. */
export function detectDebug(optionDebug?: boolean): boolean {
  if (optionDebug) return true;
  try {
    if (/[?&]tmg_debug=1\b/.test(location.search)) return true;
  } catch {
    /* noop */
  }
  try {
    if (localStorage.getItem('tmg_debug') === '1') return true;
  } catch {
    /* noop */
  }
  return false;
}

export function log(label: string, ...args: unknown[]): void {
  if (!enabled) return;
  try {
    // eslint-disable-next-line no-console
    console.log('%c[tmg]%c ' + label, 'color:#e8590c;font-weight:600', 'color:inherit', ...args);
  } catch {
    /* noop */
  }
}

export function warn(label: string, ...args: unknown[]): void {
  if (!enabled) return;
  try {
    // eslint-disable-next-line no-console
    console.warn('[tmg] ' + label, ...args);
  } catch {
    /* noop */
  }
}

/** Mask identity traits for debug output. */
export function maskTraits(t: { email?: string; phone?: string; externalLeadId?: string }): Record<string, string> {
  return {
    email: maskEmail(t.email),
    phone: maskPhone(t.phone),
    externalLeadId: t.externalLeadId ? t.externalLeadId : '',
  };
}

export { maskKey };
